export default __webpack_public_path__ + "static/media/face_3_19.470f11e5.png";